
import { defineComponent, PropType } from 'vue'
import { Maybe, VerifiableDomain } from '~/types/types'

export default defineComponent({
  name: 'ConfigureSSO',
  props: {
    verifiableDomain: {
      type: Object as PropType<Maybe<VerifiableDomain>>,
      required: true
    },
    savingChanges: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      xmlMetadataUrl: ''
    }
  },
  methods: {
    closeModal(close?: () => void) {
      this.xmlMetadataUrl = ''
      close?.()
    }
  },
  computed: {
    CONFIGURE_DOCS_LINK(): string {
      return ''
    }
  }
})
